import { render, staticRenderFns } from "./comptageCaisses.vue?vue&type=template&id=5d8bb532&"
import script from "./comptageCaisses.vue?vue&type=script&lang=ts&"
export * from "./comptageCaisses.vue?vue&type=script&lang=ts&"
import style0 from "./comptageCaisses.vue?vue&type=style&index=0&id=5d8bb532&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports